export enum VideoTypeEnum {
	LEFT_VIDEO = 'left_video',
	RIGHT_VIDEO = 'right_video',
	CENTER_VIDEO = 'center_video',
	WIDE_VIDEO = 'wide_video'
}
